import { Button, Card, Descriptions, Divider, Flex, Grid, Modal, Tag, Typography, message, Image } from "antd";
import { Icon } from "@iconify/react";
import { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Link, useNavigate, useParams } from "react-router";
import { customerService } from "../../../services/customer.service";
import { API_BASE_URL } from "../../../config/api.config";
import RenderIf from "../../../components/RenderIf";

export default function CustomerVerificationDetail() {

  const navigate = useNavigate()

  const breakpoint = Grid.useBreakpoint()

  const [messageApi] = message.useMessage()

  const [previewImage, setPrevieImage] = useState('')

  const { id } = useParams()

  const { data: customerData } = useQuery({
    queryKey: ['customerData', id],
    queryFn: () => customerService.getVerificationById(id),
  })

  const acceptMutation = useMutation({
    mutationKey: ['acceptMutation'],
    mutationFn: () => customerService.updateVerification(id, { status: 'accepted' }),
    onSuccess: () => {
      messageApi.success("Pelanggan berhasil diverifikasi")
      return navigate("/user-management/customer-verification")
    }
  })

  const rejectMutation = useMutation({
    mutationKey: ['rejectMutation'],
    mutationFn: (val) => customerService.updateVerification(id, { status: 'rejected' }),
    onSuccess: () => {
      messageApi.success("Pelanggan berhasil ditolak")
      return navigate("/user-management/customer-verification")
    }
  })

  const handleReject = () => {
    Modal.confirm({
      centered: true,
      title: "Pemberitahuan",
      content: "Yakin ingin menolak pelanggan ?",
      onOk: () => rejectMutation.mutate()
    })
  }

  const handleAccept = () => {
    Modal.confirm({
      centered: true,
      title: "Pemberitahuan",
      content: "Yakin ingin memverifikasi pelanggan ?",
      onOk: () => acceptMutation.mutate()
    })
  }

  return (
    <>
      <Card
        title="Informasi Pelanggan"
      >
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Informasi Utama"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { span: 2, label: 'Nama Lengkap', children: customerData?.data?.name },
            { label: 'Nomen', children: customerData?.data?.nomen },
            { label: 'No Telepon', children: customerData?.data?.phoneNumber },
            { label: 'No Telepon Baru', children: customerData?.data?.newPhoneNumber },
            { label: 'Waktu Verifikasi', children: customerData?.data?.verifiedAt },
            { span: 2, label: 'Email', children: customerData?.data?.email },
            { span: 2, label: 'Alamat', children: customerData?.data?.address },
          ]}
        />
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          size="small"
          title="Informasi Bisnis"
          styles={{ label: { width: 200 } }}
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          style={{ marginTop: 24 }}
          items={[
            { label: 'Area Bisnis', children: customerData?.data?.ab },
            { label: 'Rayon', children: customerData?.data?.rayon },
            { label: 'Area', children: customerData?.data?.area },
          ]}
        />
        <Descriptions
          column={1}
          bordered
          style={{ marginTop: 24 }}
          size="small"
          title="Dokumen Pendukung Verifikasi"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            {
              label: 'Dokumen Verifikasi',
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{customerData?.data?.supportingDocuments}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                      variant="filled"
                      color="primary"
                      size="small"
                      style={{ fontSize: 12 }}
                    >
                      <Link to={`${API_BASE_URL}/files/customer-verification/${customerData?.data?.supportingDocuments}?download=true`} >
                        Unduh
                      </Link>
                    </Button>
                  </Flex>
                </Flex>
              )
            },
          ]}
        />
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          size="small"
          title="Informasi Verifikasi"
          styles={{ label: { width: 200 } }}
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          style={{ marginTop: 24 }}
          items={[
            {
              label: 'Status Verifikasi',
              children: (
                customerData?.data?.verificationStatus === 'pending' ? (
                  <Tag color="orange">Menunggu Verifikasi</Tag>
                ) : customerData?.data?.verificationStatus === 'accepted' ? (
                  <Tag color="green">Terverifikasi</Tag>
                ) : customerData?.data?.verificationStatus === 'rejected' ? (
                  <Tag color="red">Ditolak</Tag>
                ) : (
                  <Tag color="default">Belum Terverifikasi</Tag>
                )
              )
            },
            { label: 'Verifikator', children: customerData?.data?.verificator },
            { label: 'Waktu Verifikasi', children: customerData?.data?.verifiedAt },
          ]}
        />
        <RenderIf when={customerData?.data?.verificationStatus == 'pending'} >
          <Flex key={'1'} justify="flex-end" gap={12} style={{ marginTop: 10 }} >
            <Button
              variant="outlined"
              color="danger"
              disabled={!customerData?.data?.verificationStatus === 'pending' || customerData?.data?.verificationStatus === null}
              onClick={() => handleReject()}
            >
              Tolak
            </Button>
            <Button
              variant="solid"
              color="primary"
              disabled={!customerData?.data?.verificationStatus === 'pending' || customerData?.data?.verificationStatus === null}
              onClick={() => handleAccept()}
            >
              Terima
            </Button>
          </Flex>
        </RenderIf>
      </Card>
      <Modal
        open={previewImage.length > 0}
        centered
        title="Gambar"
        onCancel={() => setPrevieImage('')}
        footer={[
          <Button variant="outlined" color="primary" key="cancel" onClick={() => setPrevieImage('')}>
            Cancel
          </Button>
        ]}
      >
        <Image src={previewImage} />
      </Modal>
    </>
  )
}